<style scoped lang="less">
.layout{position: absolute; background: rgba(2, 36 ,38,.5);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;border-radius: 10px; bottom: 12px;height: 400px; top: 40%;left: 45%;transform: translate(-50%, -50%);}
.title{width: 660px; height: 30px;background: rgba(33, 185, 191, 0.6);margin: 0;line-height: 30px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.popup-content {width: 690px;height: 370px;;color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: 5px;}
.ol-popup-closer:after {content: "✖";}
//设置整个table样式
/deep/.el-table{background: none !important;}
//修改表格头部样式
/deep/.el-table tr {background: none !important; }
/deep/.el-table tr .is-center{background: none !important; color: #fff; border: none;}
//修改分页菜单yangs
/deep/.el-pager li{background: transparent !important; color: #fff;}
/deep/.el-pager > .active{background: transparent !important; color: #23fffc;}
/deep/.btn-prev{background: transparent !important;color: #fff !important;}
/deep/.btn-next{background: transparent !important;color: #fff !important;}
/deep/.el-table__header th {padding: 0;height: 30px;}
/deep/.el-table__body td {padding: 0;height: 30px;}
.echarts {height: 40px;line-height: 40px;}
.echarts span{display: inline-block;height: 30px;line-height: 30px;;border: 1px solid rgba(33, 185, 191, 0.6);padding: 0px 5px;}
.echarts span:hover {cursor: pointer;}
.positioning {cursor: pointer;}
</style>

<template>
  <div class="layout" v-drag v-if="flag">
    <p class="title">
      <span>缓冲区分析</span>
      <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
    </p>
    <div class="popup-content">
      <div class="echarts">
        <span @click="drawbar('bar')"><i class="iconfont icon-zhuzhuangtu"></i>柱状图</span>
        <span @click="drawbar('pie')"><i class="iconfont icon-bingzhuangtu"></i>饼图</span>
        <span @click="drawbar('line')"><i class="iconfont icon-tubiao-zhexiantu"></i>折线图</span>
        <span @click="onClickExpExcel()"><i class="iconfont icon-daochu"></i>导出报表</span>
      </div>
      <el-table :header-cell-style="headercell" :row-style='rowstyles' :data="tableData" stripe height="320" style="width: 100%">
        <el-table-column align="center" prop="owner" label="国家"></el-table-column>
        <el-table-column align="center" prop="scale" label="规模"></el-table-column>
        <el-table-column align="center" prop="type" label="类型"></el-table-column>
        <el-table-column align="center" prop="type" label="位置">
          <template slot-scope="scope">
            <span @click="positioning(scope.row)" class="positioning">定位</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import 'ol/ol.css'
import VectorLayer from 'ol/layer/Vector'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
import Style from 'ol/style/Style'
import WFS from 'ol/format/WFS'
import {bbox} from 'ol/format/filter'
import Axios from 'axios'
import Feature from 'ol/Feature'
import Circle from 'ol/geom/Circle'
import Vector from 'ol/source/Vector'
import SpaceQuery from './SpaceQuery'
export default {
  mixins: [SpaceQuery],
  data()
  {
    return {
      measureAry: [],
      flag: false,
      tableData: [],
      temp: [],
      xAxisdata: [],
      seriesdata: [],
      LayernarData: [],
      obj: [],
      Layernar: [],
      bufferanalysisFlag: false
    }
  },
  computed: {
    TableData()
    {
      return this.tableData
    },
    ...mapState({
      curID: state => state.searchtype
    })
  },
  watch: {
    curID:
    {
      handler(nval, oval)
      {
        this.bufferanalysisFlag = nval
      },
      immediate: true
    }
  },
  methods:
  {
    //绘制缓冲区
    bufferanalysis(obj, Layernar)
    {
      this.obj = obj
      this.Layernar = Layernar
      window.map.on('click', this.handler)
    },
    handler(evt)
    {
      let self = this
      let coordinate = evt.coordinate
      if (self.Layernar.length === 0)
        return this.$message({message: '请先勾选图层', type: 'warning', customClass: 'mzindex'})
      let rome = new Feature({
        geometry: new Circle(coordinate, +self.obj.radius) //几何信息
      })
      var vector = new Vector()
      vector.addFeature(rome)
      var wfsVectorLayer = new VectorLayer({
        source: vector,
        style: new Style({
          fill: new Fill({
            color: 'rgba(0, 0, 0, 0.4)',
            width: 1
          }),
          stroke: new Stroke({
            color: '#ffcc33',
            width: 1
          })
        })
      })
      self.LayernarData.push(wfsVectorLayer)
      window.map.addLayer(wfsVectorLayer)
      if (self.bufferanalysisFlag)
        self.loadWfsGetFeatures(rome, self.Layernar)
      else
        window.map.un('click', self.handler)
    },
    //属性分析
    async loadWfsGetFeatures(feature, Layernar)
    {
      this.$parent.loading = true
      let featureRequest = new WFS().writeGetFeature({
        srsName: 'EPSG:4326',
        featureNS: 'http://www.camining.cn/geoserver/gisdny/',
        featureTypes: Layernar,
        outputFormat: 'application/json',
        filter: bbox('the_geom', feature.getGeometry().getExtent(), 'EPSG:4326')
      })
      let conf =
      {
        headers: {'Content-Type': 'application/json'}
      }
      let ret = await Axios.post('http://www.camining.cn/geoserver/gisdny/wfs', new XMLSerializer().serializeToString(featureRequest), conf)
      if (ret.data.features.length > 0)
      {
        this.flag = true
        let fidary = ret.data.features.map(item =>
        {
          return item.id.split('.')[1]
        })
        this.temp = fidary
        this.getDmkcary(fidary)
      }
      else
        this.$parent.loading = false
    },
    //清除缓冲区
    clear()
    {
      this.LayernarData.forEach(e =>
      {
        e.getSource().clear()
        window.map.removeLayer(e)
      })
      //关闭缓冲区分析表格
      this.flag = false
    },
    //关闭插件
    closePul(show)
    {
      this.flag = show
      this.$emit('closeEcharts')
    },
    //表头样式设置
    headercell(row, column, rowIndex, columnIndex)
    {
      return 'background: rgba(35, 134, 135, 0.7) !important;color: #23fffc;'
    },
    //修改表格行样式
    rowstyles({row, rowIndex})
    {
      if (rowIndex % 2 === 1)
      {
        let styleJson = {
          'background': 'rgba(2,36,38, .8) !important'
        }
        return styleJson
      }
      else
      {
        let styleJson = {
          'background': 'rgba(44,74,73, .8) !important'
        }
        return styleJson
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/BufferAnalysis.vue